import React from 'react'
import MetaBaseDashBoardTwo from '../../features/MetabaseDashBoard/MetaBaseDashBoardTwo'

const MetabaseReport1 = () => {
  return (
    <div><MetaBaseDashBoardTwo/></div>
  )
}

export default MetabaseReport1